module.exports = __webpack_public_path__ + "static/media/logoFooter.061304c4.png";